/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OrgOverview_purchasedCourses = {
    readonly edges: ReadonlyArray<{
        readonly counts: {
            readonly expiringTakers: number;
        };
    } | null> | null;
    readonly " $refType": "OrgOverview_purchasedCourses";
};
export type OrgOverview_purchasedCourses$data = OrgOverview_purchasedCourses;
export type OrgOverview_purchasedCourses$key = {
    readonly " $data"?: OrgOverview_purchasedCourses$data;
    readonly " $fragmentRefs": FragmentRefs<"OrgOverview_purchasedCourses">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "OrgOverview_purchasedCourses",
    "type": "PurchasedCoursePage",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PurchasedCourse",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "counts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PurchasedCourseCount",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "expiringTakers",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '646a4d3bcac5837bd2778b389edb6149';
export default node;
